/// \file error.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useRouteError } from "react-router-dom";
import { ApiError } from "../errors/ApiError";

const ErrorPage = () => {
  const error = useRouteError() as ApiError;
  let isAccessDenied = false;

  if(error?.statusCode === 401) {
    isAccessDenied = true;
  }

  const loginLink = (
    <Nav.Link to="/auth/signin" as={NavLink}>
      Signin
    </Nav.Link>
  );  

  return (
    <div>
      <center>
        <h1>Error: {error.statusCode}</h1>
        <p>{error.message}</p>
      </center>
      {isAccessDenied && <center>{loginLink}</center> }
    </div>
  );
};

export default ErrorPage;